import ApiInstance from '../../interfaces/api-instance';
import { getSessionTokenFromUrl } from '../../utilis/session-token';
import { DEMO_MEDIA_ROUTES } from './route';

/**
 * The exercise images/videos for this demo session — `{ images: [...urls],
 * videos: [...urls] }`. Fetched from camera-permission, well before the
 * exercise page needs any of it, so it can be prefetched into the browser
 * cache while there's dwell time to spare (see utilis/session-media-cache.js).
 */
export async function getSessionMedia(sessionId, options = {}) {
  const { data } = await ApiInstance.get(DEMO_MEDIA_ROUTES.GET_SESSION_MEDIA(sessionId), {
    params: { session_token: getSessionTokenFromUrl() },
    signal: options.signal,
    // A session that hasn't fully authenticated yet must not bounce the
    // patient to /login over a prefetch call — this is a pure optimization,
    // never the reason a session fails.
    skipAuthRedirect: true,
  });
  return data;
}
